import { useFieldArray, useFormContext, Controller } from "react-hook-form";
import { Box, Button, Chip, TextField, Typography } from "@mui/material";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useState } from "react";
import { PaymentAddRecipientsIcon } from "../../../../../assets/icons/MUI/PaymentIcons";
import { useTranslation } from "react-i18next";

const RecipientsOutsideGoalngoInput = () => {
  const { t } = useTranslation();

  const {
    control,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "recipientsOutSideGoalngo",
  });

  const [email, setEmail] = useState("");

  const recipients = watch("recipientsOutSideGoalngo", []);

  const emailSchema = z.string().email("VALID_RECIPIENTS_EMAIL");

  const handleAddEmail = () => {
    try {
      emailSchema.parse(email);

      if (recipients.includes(email)) {
        setError("recipientsOutSideGoalngo", { message: "DUPLICATE_EMAIL" });
        return;
      }

      append(email);
      setEmail("");
      clearErrors("recipientsOutSideGoalngo");
    } catch (err) {
      setError("recipientsOutSideGoalngo", { message: "VALID_RECIPIENTS_EMAIL" });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "24px", padding: "16px" }}>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {fields.map((item, index) => (
          <Chip variant="outlined" key={item.id} label={recipients[index]} onDelete={() => remove(index)} />
        ))}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px" }}>
        <Typography component="label" sx={{ color: "#111", fontSize: "14px", fontWeight: 600, lineHeight: "24px" }}>
          {t("pages.payment.createPaymentLink.email")}
        </Typography>
        <Box
          sx={{
            display: "flex",
            border: "1px solid",
            borderRadius: "33px",
            width: "100%",
            borderColor: errors.recipientsOutSideGoalngo?.message ? "red" : "#CFCFCF",
            overflow: "hidden",
            bgcolor: recipients.length === 50 ? "#F5F6F5" : "#FFF",
          }}
        >
          <Controller
            name="emailInput"
            control={control}
            render={() => (
              <TextField
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                disabled={recipients.length === 50}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": { border: "none !important" },
                  "& .MuiInputBase-root": { border: "none !important" },
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleAddEmail();
                  }
                }}
              />
            )}
          />
          <Button
            variant="secondary-md"
            sx={{ whiteSpace: "nowrap", borderRadius: 0, border: "none !important" }}
            startIcon={<PaymentAddRecipientsIcon />}
            onClick={handleAddEmail}
          >
            Add
          </Button>
        </Box>
        {errors.recipientsOutSideGoalngo?.message && (
          <Typography
            sx={{
              color: "red",
              fontSize: "12px",
              fontWeight: 500,
              marginTop: "4px",
            }}
          >
            {t(`pages.payment.createPaymentLink.${String(errors.recipientsOutSideGoalngo?.message)}`)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default RecipientsOutsideGoalngoInput;
